<template>

</template>

<script>
  export default {
    data: () => ({
      saveButtonDisabled: false
    }),

    async created() {
      this._lot = _.cloneDeep(this.lot);
    },

    methods: {
      async checkForm(lot) {
        if (!this.canEditFull && !this.canEditPartially) return;

        if (!lot) {
          lot = this.lot;
        }

        const changed = !_.isEqual(lot, this._lot);

        if (lot.permissions.CAN_MANUALLY_SAVE_LOT) {
          this.saveButtonDisabled = !changed;
          this.$store.commit('saveLot', lot);
        }
        else if (changed) {
          await this.updateLot(lot);
        }
      },

      async updateLot(lot, onSuccess) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('updateLot', lot);

            if (onSuccess) {
              onSuccess();
            }
          }
          catch(e) {
            console.log('unable to update lot', e);
            this.globalErrorHandler(e, undefined, 'errors.failed-updating-lot');
          }
        });
      },

      async saveChanges() {
        await this.updateLot(this.lot, () => {
          if (this.currentUser.isMain) {
            this.showError({
              title: 'Сохранение изменений',
              error: 'Изменение опубликовано на публичной странице лота'
            });
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
